export default {
  setAlert(state, value) {
    state.alert = value;
  },
};